import useMediaQuery from '@mui/material/useMediaQuery';
export default function useDeviceMedia() {
    const isPortrait = useMediaQuery("(orientation: portrait)");
    const isMobile = useMediaQuery((theme) => theme.breakpoints.down('md'));
    const isMobilePortrait = isMobile && isPortrait;
    return { isMobile, isPortrait, isMobilePortrait };
}